// extracted by mini-css-extract-plugin
module.exports = {"grid":"Jobs_grid__1aX2K","card":"Jobs_card__1wz_6","cardCover":"Jobs_cardCover__3aVyy","cardContent":"Jobs_cardContent__2yMiH"};